import React from 'react';

const JobListingCardSkeleton: React.FC = () => {
  return (
    <div className="card mb-3">
      <div className="card-body">
        {/* タイトル部分のスケルトン */}
        <div className="mb-3">
          <div 
            className="skeleton-line" 
            style={{ 
              height: '1.5rem', 
              width: '85%', 
              marginBottom: '0.5rem',
              borderRadius: '4px'
            }}
          ></div>
          <div 
            className="skeleton-line" 
            style={{ 
              height: '1.2rem', 
              width: '70%', 
              marginBottom: '0.5rem',
              borderRadius: '4px'
            }}
          ></div>
        </div>

        {/* メタ情報のスケルトン */}
        <div className="mb-3">
          <div className="d-flex gap-2 mb-2">
            <div 
              className="skeleton-badge" 
              style={{ 
                height: '1.5rem', 
                width: '4rem',
                borderRadius: '4px'
              }}
            ></div>
            <div 
              className="skeleton-badge" 
              style={{ 
                height: '1.5rem', 
                width: '3.5rem',
                borderRadius: '4px'
              }}
            ></div>
            <div 
              className="skeleton-badge" 
              style={{ 
                height: '1.5rem', 
                width: '3rem',
                borderRadius: '4px'
              }}
            ></div>
          </div>
        </div>

        {/* スキル部分のスケルトン */}
        <div className="mb-3">
          <div className="d-flex align-items-center flex-wrap gap-1">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '0.7rem', 
                width: '12px',
                borderRadius: '2px'
              }}
            ></div>
            <div 
              className="skeleton-badge" 
              style={{ 
                height: '1.2rem', 
                width: '3.5rem',
                borderRadius: '4px'
              }}
            ></div>
            <div 
              className="skeleton-badge" 
              style={{ 
                height: '1.2rem', 
                width: '4rem',
                borderRadius: '4px'
              }}
            ></div>
            <div 
              className="skeleton-badge" 
              style={{ 
                height: '1.2rem', 
                width: '2.8rem',
                borderRadius: '4px'
              }}
            ></div>
          </div>
        </div>

        {/* 職種部分のスケルトン */}
        <div className="mb-3">
          <div className="d-flex align-items-center flex-wrap gap-1">
            <div 
              className="skeleton-line" 
              style={{ 
                height: '0.7rem', 
                width: '12px',
                borderRadius: '2px'
              }}
            ></div>
            <div 
              className="skeleton-badge" 
              style={{ 
                height: '1.2rem', 
                width: '4.5rem',
                borderRadius: '4px'
              }}
            ></div>
            <div 
              className="skeleton-badge" 
              style={{ 
                height: '1.2rem', 
                width: '3.8rem',
                borderRadius: '4px'
              }}
            ></div>
          </div>
        </div>

        {/* フッター部分のスケルトン */}
        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
          <div 
            className="skeleton-line" 
            style={{ 
              height: '0.8rem', 
              width: '60%',
              borderRadius: '4px'
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default JobListingCardSkeleton;
